// Date utility functions for consistent date formatting across the application

export function dateToMonDDYYYY(dateString) { 
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    return "--";
  }

  const [year, month, day] = dateString.split("-");
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const monthName = months[parseInt(month, 10) - 1];
  return `${monthName} ${day} ${year}`;
}



export function dateTimeToMonDDYYYYWithTime(dateString, withTime = true) {

  let date;

  // Handle ISO 8601 format (e.g., 2025-06-20T09:50:37.299Z)
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(dateString)) {
    if(dateString.includes('T00:00:00.000Z')) {
      // Normalize midnight UTC to noon UTC to avoid previous-day shifts in LA across DST
      dateString = dateString.replace('T00:00:00.000Z', 'T12:00:00.000Z');
    }
    date = new Date(dateString);
  }
  // Handle PostgreSQL timestamp format (e.g., 2025-06-20 02:50:37.299 -0700)
  else if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}\.\d{3} [+-]\d{4}$/.test(dateString)) {
    console.log(2);
    // Replace space before timezone offset with 'T' for compatibility with Date parsing
    const isoCompatibleString = dateString.replace(' ', 'T');
    date = new Date(isoCompatibleString);
  } else {
    return "--"; // Invalid format
  }

  // Convert to Los Angeles time using Intl API
  const losAngelesTime = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Los_Angeles",
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).formatToParts(date);

  // Extract components
  const year = losAngelesTime.find((part) => part.type === "year").value;
  const month = losAngelesTime.find((part) => part.type === "month").value;
  const day = losAngelesTime.find((part) => part.type === "day").value;

  if (!withTime) {
    // Return formatted date only
    return `${month} ${day}, ${year}`;
  }

  const hours = losAngelesTime.find((part) => part.type === "hour").value;
  const minutes = losAngelesTime.find((part) => part.type === "minute").value;
  const seconds = losAngelesTime.find((part) => part.type === "second").value;

  // Convert 24-hour format to 12-hour format
  const hourNumber = parseInt(hours, 10);
  const amPm = hourNumber >= 12 ? "PM" : "AM";
  const adjustedHours = hourNumber % 12 || 12;

  // Return formatted date and time
  return `${month} ${day}, ${year} ${adjustedHours}:${minutes}:${seconds} ${amPm}`;
}

export function convertTo12HourFormat(time) {
  let [hours, minutes, seconds] = time.split(":").map(Number);
  let ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert hour to 12-hour format
  return `${hours}:${minutes.toString().padStart(2, "0")} ${ampm}`;
}

// yyyy-mm-dd to MMM DD, YYYY
export function formatDateToMMMDDYYYY(dateInput) {
  return dateTimeToMonDDYYYYWithTime(dateInput+'T12:00:00.000Z', false);
}